import React, { createContext, useContext, useState, useEffect } from "react";
import firebase from "./firebase";
import jwtDecode from "jwt-decode";

const UserContext = createContext({});

export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const decodeThenSetUser = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      const { user_id, display_name, email } = decodedToken;
      setUser({ user_id, display_name, email });
    } catch (error) {
      setUser(null);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    decodeThenSetUser(token);
  }, []);

  const loginSSO = async () => {
    const loginWindow = window.open(`/auth/sso`, "_blank", "popup");

    return new Promise((resolve, reject) => {
      const listener = (message) => {
        if (message.source !== loginWindow) return;
        loginWindow?.close();

        (async () => {
          const data = message.data;
          if (data.token) {
            localStorage.setItem("token", data?.token || "");

            return {
              status: true,
              message: data?.message ?? "Login success",
              token: data.token,
            };
          }
          return {
            status: false,
            message: data?.message ?? "Login failed",
          };
        })()
          .then(async (data) => {
            if (data.status) {
              decodeThenSetUser(data.token);
              window.location.href = "/";
            } else {
              // munclin toast
            }
            return resolve(data);
          })
          .catch(async (reason) => {
            // Kalo Server Error
            reject(reason);
            // munculin toast
          });
      };
      window.addEventListener("message", listener);
    });
  };

  const loginGoogle = async () => {
    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      const result = await firebase.auth().signInWithPopup(provider);
      const idToken = await result.user.getIdToken();

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/auth/firebase`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { token } = data;
        localStorage.setItem("token", token);
        decodeThenSetUser(token);
        window.location.href = "/";
      } else {
        //toast
        console.error("err auth");
      }
    } catch (error) {
      //toast
      console.error("err server error");
    }
  };

  const logout = async () => {
    setUser(null);
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const value = {
    user,
    loginSSO,
    loginGoogle,
    logout,
  };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
